import { useContext } from "react";

import { PersonasContext } from "../PersonasProvider";

export const usePersonas = () => {
  const personaContextValues = useContext(PersonasContext) ?? {};

  return personaContextValues;
};
